module.exports = __webpack_public_path__ + "img/img2.e20b6f05.png";